import type { ScheduledTaskRunStatus } from '@/types/scheduledTasks'

export function formatAbsolute(iso: string): string {
  return new Date(iso).toLocaleString()
}

// Relative label ("in 5 minutes", "3 hours ago") via the native Intl API so no
// user-visible text is hardcoded.
export function formatRelative(iso: string): string {
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })
  const diffSec = Math.round((new Date(iso).getTime() - Date.now()) / 1000)
  if (Math.abs(diffSec) < 60) return rtf.format(diffSec, 'second')
  const diffMin = Math.round(diffSec / 60)
  if (Math.abs(diffMin) < 60) return rtf.format(diffMin, 'minute')
  const diffHour = Math.round(diffMin / 60)
  if (Math.abs(diffHour) < 24) return rtf.format(diffHour, 'hour')
  return rtf.format(Math.round(diffHour / 24), 'day')
}

// 850 -> "850 ms", 1200 -> "1.2 s", 123000 -> "2 min 3 s"
export function formatDuration(ms: number): string {
  if (ms < 1000) return `${ms} ms`
  const totalSeconds = ms / 1000
  if (totalSeconds < 60) return `${Math.round(totalSeconds * 10) / 10} s`
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = Math.round(totalSeconds - minutes * 60)
  return seconds === 0 ? `${minutes} min` : `${minutes} min ${seconds} s`
}

export function statusBadgeClass(status: ScheduledTaskRunStatus): string {
  switch (status) {
    case 'succeeded':
      return 'bg-emerald-500/20 text-emerald-400'
    case 'failed':
      return 'bg-red-500/20 text-red-400'
    case 'running':
      return 'bg-sky-500/20 text-sky-400'
    case 'queued':
      return 'bg-slate-500/20 text-slate-300'
    case 'skipped':
      return 'bg-amber-500/20 text-amber-400'
    case 'abandoned':
      return 'bg-orange-500/20 text-orange-400'
  }
}
